import { render, staticRenderFns } from "./GlobalSingle.vue?vue&type=template&id=3d588a16&scoped=true"
import script from "./GlobalSingle.vue?vue&type=script&lang=js"
export * from "./GlobalSingle.vue?vue&type=script&lang=js"
import style0 from "./GlobalSingle.vue?vue&type=style&index=0&id=3d588a16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d588a16",
  null
  
)

export default component.exports